import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 540px; 
  max-height: 400px;
  width: 100%;
  z-index: 11;
  display: flex;
  justify-content: center;
  position: relative;
  top: -60px;
`;

export const Container = styled.div`
  width: 84.37%;
  padding-top: 55.66%;
  z-index: 11;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  align-items: center;
  position: relative; 
`;

export const ResultWrap = styled.div`
  width: 14%; 
`;

export const ResultImg = styled.div`
  width: 100%; 
  padding-top: 100%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover; 
`;

export const ResultWrap2 = styled.div`
  width: 100%;
`;

export const ResultImg2 = styled.div`
  width: 100%; 
  padding-top: 14%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover; 
`;

export const ActionGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: calc(100% + 32px);
  left: 50%;
  transform: translateX(-50%);
`;
